module.exports = __webpack_public_path__ + "static/img/leventhal-No4_USNews.43efcd4.png";


//////////////////
// WEBPACK FOOTER
// ./static/leventhal-No4_USNews.png
// module id = Nxd/
// module chunks = 1